const extractHTML = (string, selector) => {
  const dummyElement = document.createElement("div");
  dummyElement.innerHTML = string;
  return dummyElement.querySelector(selector);
};
export default extractHTML;